import React from 'react';
import { InNavbarComponent } from './navbar.types';
import { Navbar, Logo } from './navbar.styles';

const NavbarComponent: React.FC<InNavbarComponent> = (
  props: InNavbarComponent,
) => (
  <Navbar>
    <a href={props.logoGoTo}>
      <Logo component={'img'} />
    </a>
  </Navbar>
);

export default NavbarComponent;
